import { useState } from "react";

const useCredential = () => {

      const [user, setUser] = useState({})
      const [vehicleData, setVehicleData] = useState([])
      const [outletCode, setOutletCode] = useState("")
      const [deliveryOutlets, setDeliveryOutlets] = useState([])
      const [startDate, setStartDate] = useState(new Date());
      const [endDate, setEndDate] = useState(new Date());

      return {
            user,
            setUser,
            vehicleData,
            setVehicleData,
            outletCode,
            setOutletCode,
            deliveryOutlets,
            setDeliveryOutlets,
            startDate,
            setStartDate,
            endDate,
            setEndDate
      }
};

export default useCredential;